module.exports = __webpack_public_path__ + "src/img/sketchrunner/laptop-2.13530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sketchrunner/laptop-2.jpg
// module id = 255
// module chunks = 0